'use client';
import MainSearch from '@/app/_components/ui/icons/MainSearch.svg';
import { useState, useRef, useEffect, useCallback } from 'react';
import Link from 'next/link';
import CatIcon from '@/app/_components/ui/icons/CatIcon.svg';
import Image from 'next/image';
import { useRouter, usePathname } from 'next/navigation';
import { GET_PRODUCTS_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';

// Debounce function
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}

export default function Searchbar() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showResultWrap, setShowResultWrap] = useState(false);
  const [searchText, setSearchText] = useState('');
  const resultWrap = useRef(null);
  const path = usePathname();
  const router = useRouter();

  const closeResultWrap = (e) => {
    if (
      resultWrap.current &&
      showResultWrap &&
      !resultWrap.current.contains(e.target)
    ) {
      setShowResultWrap(false);
    }
  };

  useEffect(() => {
    setSearchText('');
    setProducts([]);
    setShowResultWrap(false);
  }, [path]);

  const handleSearch = useCallback(
    debounce(async (query) => {
      if (!query.trim()) {
        setProducts([]);
        setShowResultWrap(false);
        return;
      }

      const res = await fetch(
        `${GET_PRODUCTS_ENDPOINT}?s=${query}&limit=8&search_box=true`,
        {
          method: 'get',
          headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          }),
        }
      );

      if (res.ok) {
        const result = await res.json();
        setProducts(result.products);
        setCategories(result.categories);
        setShowResultWrap(true);
      }
    }, 300), // Adjust the debounce delay as needed
    []
  );

  const handleChange = (event) => {
    const query = event.target.value;
    setSearchText(query);
    handleSearch(query);
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeResultWrap);
    return () => {
      document.removeEventListener('mousedown', closeResultWrap);
    };
  }, [showResultWrap]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    router.push(`/search?s=${searchText}`);
  };

  return (
    <>
      <div className="header-search-form flex-1 md:pr-4 sm:relative flex justify-center items-center">
        <form
          onSubmit={handleFormSubmit}
          className="flex justify-center items-center w-full"
        >
          <input
            onChange={handleChange}
            type="text"
            className="form-control block w-full pr-10 py-2  text-gray-700  bg-clip-padding border border-light-gray-250 placeholder:text-gray-400 md:placeholder:text-sm xs:placeholder:text-xs rounded-lg focus:text-gray-700  focus:outline-none"
            placeholder="محصول مورد نظر خود را جستجو کنید "
            name="s"
            autoComplete="off"
            value={searchText}
          />
          <span className="absolute  right-4 md:right-6">
            <MainSearch />
          </span>
        </form>
        <div
          className={`absolute top-14 bg-white shadow-md z-40 w-full leading-9 right-0 rounded-md ${
            showResultWrap ? '' : 'hidden'
          }`}
          ref={resultWrap}
        >
          <div className="p-4 text-sm">
            {categories?.length > 0 && (
              <ul>
                {categories.slice(0, 3).map((category) => (
                  <li
                    key={category.url}
                    className="border-b border-light-gray-150 "
                  >
                    <Link
                      className="flex py-2"
                      href={`/${category.type == 'brand' ? 'brand' : 'cat'}${
                        category.url
                      }`}
                    >
                      <div className="flex items-center">
                        <span className=" linline-block pl-2">
                          <CatIcon />
                        </span>
                        {` دسته بندی ${category.title}`}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
            {products.length > 0 ? (
              <>
                <ul>
                  {products
                    .slice(0, 8 - Math.min(categories.length, 3))
                    .map((product, index) => (
                      <li
                        key={product.slug}
                        className="border-b border-light-gray-150 last:border-none"
                      >
                        <div className="flex items-center py-2">
                          <Link
                            href={`/product/${product.slug}`}
                            className="flex"
                          >
                            <Image
                              src={product.media.thumb.full_path}
                              width={43}
                              height={40}
                              alt={product.media.thumb.alt}
                            />
                            <div className="leading-7">{product.title}</div>
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
                <div className="text-center mt-2 sm:p-2 text-white rounded-md bg-color-primary">
                  <Link href={`/search?s=${searchText}`}>
                    مشاهده نتایج بیشتر
                  </Link>
                </div>
              </>
            ) : (
              <div>نتیجه ای یافت نشد </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
